export default "__VITE_ASSET__24c83334__"